import { Currency } from '@/core/currency/interfaces';

const CUC: Currency = {
    name: 'Cuban convertible Peso',
    demonym: 'Cuban Convertible',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '931',
    symbol: 'CUC$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CUC',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CUC;
